import type { i18nStringType } from "i18n/i18nString";

type Input = {
  downloadUrl?: string;
  isBeforeRange?: boolean;
  isAfterRange?: boolean;
};

export const getDownloadLabelKey = (input: Input): i18nStringType => {
  const { downloadUrl, isBeforeRange, isAfterRange } = input;
  if (isBeforeRange) return "settlementHistory.downloadPreparing";
  if (isAfterRange) return "settlementHistory.downloadExpired";
  if (!downloadUrl) return "settlementHistory.downloadPreparing";

  return "settlementHistory.download";
};
